<template>
  <div v-for="parameter in displayedParameters" :key="parameter.id">
    <FilterTag
      v-for="item in getParameterItems(parameter)"
      :key="item?.id"
      :style-source="parameter"
      :link="parameterValueQuery(item, parameter) === null ? null : translatePath(ROUTES.CODE.ADS) + `?idCategory=${data?.product?.category?.id}&p[${item.parameter.id}]=${encodeURIComponent(parameterValueQuery(item, parameter))}`"
      :on-click="async () => await handleClick(item, parameter)"
    >
      {{ parameterValueLabel(item, parameter) }}
    </FilterTag>
  </div>
</template>

<script setup>
import _ from 'lodash-es';
import { parameterValueLabel, parameterValueQuery } from '@utils/parameters';
import { ROUTES } from "@utils/routes";
import FilterTag from "@components/filter/filter-tag";

const props = defineProps({
  parameters: {
    type: Array,
    required: true,
  },
  data: {
    type: Object,
    required: true
  },
  highlighted: {
    type: Boolean,
    default: false
  }
});

const { $eventBus } = useNuxtApp();

const getParameterItems = (parameter) => _.filter(
  props.data?.parameters || [],
  item => item?.parameter?.id === parameter.id &&
    item?.parameter?.highlighted === props.highlighted &&
    ((parameter.input === 'number' || parameter.input === 'text')
      ? parameterValueLabel(item, parameter) !== ''
      : item?.value?.visibleWeb === true)
);

const displayedParameters = computed(() => {
  return _.orderBy(
    _.filter(props.parameters || [], parameter => parameter?.visibleWeb === true && getParameterItems(parameter).length > 0),
    [parameter => parameter?.orderWeb ?? 0],
    ['asc']
  );
});

const closeModal = () => {
  $eventBus.emit('modal:close');
}

const handleClick = async (item, parameter) => {
  const value = parameterValueQuery(item, parameter);
  if (value === null) return;
  closeModal();
  await useSearchParam(`p[${item.parameter.id}]`, value);
}

</script>
